import deepmerge from 'deepmerge';
import { renderFont, Theme } from '@empiriecom/module-components/ThemeProvider';
import { FlattenSimpleInterpolation } from 'styled-components';

export type AvailabilityMessageLayout = 'default' | 'small';

export interface AvailabilityMessageTheme extends Theme {
  component: {
    availability: {
      [key: string]: {
        [key: string]: {
          color: string;
          font: FlattenSimpleInterpolation;
          fontSize: string;
          justifyContent: string;
          lineHeight: string;
        };
      };
    };
  };
}

// tslint:disable-next-line: arrow-return-shorthand
export const availabilityMessageTheme = (theme: Theme): AvailabilityMessageTheme => {
  const componentTheme = {
    AVAILABLE: {
      color: theme.success.color.normal,
      font: renderFont('base', 'bold', theme),
      fontSize: '0.8125rem',
      justifyContent: 'center',
      lineHeight: '1rem',
    },
    NOT_AVAILABLE: {
      color: theme.error.color.normal,
      font: renderFont('base', 'bold', theme),
      fontSize: '0.8125rem',
      justifyContent: 'center',
      lineHeight: '1rem',
    },
    NOT_YET_AVAILABLE: {
      color: theme.warning.color.normal,
      font: renderFont('base', 'bold', theme),
      fontSize: '0.8125rem',
      justifyContent: 'center',
      lineHeight: '1rem',
    },
    UNSELECTED: {
      color: theme.base.color.text,
      font: renderFont('base', 'normal', theme),
      fontSize: '0.8125rem',
      justifyContent: 'center',
      lineHeight: '1rem',
    },
  };

  const smallTheme = {
    AVAILABLE: {
      ...componentTheme.AVAILABLE,
      font: renderFont('base', 'normal', theme),
      fontSize: '0.813rem',
      justifyContent: 'flex-start',
    },
    NOT_AVAILABLE: {
      ...componentTheme.NOT_AVAILABLE,
      font: renderFont('base', 'normal', theme),
      fontSize: '0.813rem',
      justifyContent: 'flex-start',
    },
    NOT_YET_AVAILABLE: {
      ...componentTheme.NOT_YET_AVAILABLE,
      font: renderFont('base', 'normal', theme),
      fontSize: '0.813rem',
      justifyContent: 'flex-start',
    },
    UNSELECTED: {
      ...componentTheme.UNSELECTED,
      font: renderFont('base', 'normal', theme),
      fontSize: '0.813rem',
      justifyContent: 'flex-start',
    },
  };

  let finalTheme = {
    default: componentTheme,
    small: smallTheme,
  };

  if (theme.component.availability) {
    finalTheme = deepmerge(finalTheme, theme.component.availability);
  }

  return {
    ...theme,
    component: {
      ...theme.component,
      availability: finalTheme,
    },
  };
};

export default availabilityMessageTheme;
